import { sharedTypes } from './Constants';
import { setLocalStorageItem } from '../../services/Helper';

export function sendEventRequest(data, callback) {
	return {
		type: sharedTypes.SEND_EVENT_REQUEST,
		payload: { data, callback },
	};
}

export function sendEventSuccess(data) {
	return {
		type: sharedTypes.SEND_EVENT_SUCCESS,
		payload: { data },
	};
}

export function setEventSource(data) {
	return {
		type: sharedTypes.SET_EVENT_SOURCE,
		payload: { data },
	};
}

export function setPageSource(data) {
	return {
		type: sharedTypes.SET_PAGE_SOURCE,
		payload: { data },
	};
}

export function setTriggerAfterLogin(data) {
	return {
		type: sharedTypes.SET_TRIGGER_UPGRADE_MODAL,
		payload: { data },
	};
}

export function setSourceForUpgradeModalFromExplanation(data) {
	return {
		type: sharedTypes.SET_FOR_UPGRADE_MODAL_FROM_EXPLANATION,
		payload: { data },
	};
}

export function setUpgradeModalIdentifier(data) {
	return {
		type: sharedTypes.SET_UPGRADE_MODAL_IDENTIFIER,
		payload: { data },
	};
}

export function setTheme(theme, userId, selectedThemeOption) {
	setLocalStorageItem('theme', selectedThemeOption);

	return {
		type: sharedTypes.SET_THEME,
		payload: { theme, userId, selectedThemeOption },
	};
}

export function getUserCollections(type) {
	return {
		type: sharedTypes.GET_USER_COLLECTIONS,
		payload: {
			type,
		},
	};
}

export function getUserCollectionsSuccess(data) {
	return {
		type: sharedTypes.GET_USER_COLLECTIONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getUserCollectionsError() {
	return {
		type: sharedTypes.GET_USER_COLLECTIONS_ERROR,
	};
}

export function getUserSuggestedSubjects() {
	return {
		type: sharedTypes.GET_USER_SUGGESTED_SUBJECTS,
	};
}

export function getUserSuggestedSubjectsSuccess(data) {
	return {
		type: sharedTypes.GET_USER_SUGGESTED_SUBJECTS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getUserSuggestedSubjectsError() {
	return {
		type: sharedTypes.GET_USER_SUGGESTED_SUBJECTS_ERROR,
	};
}

export function getTFAData(data) {
	return {
		type: sharedTypes.GET_TFA_DATA,
		payload: data,
	};
}

export function getTFADataSuccess(data) {
	return {
		type: sharedTypes.GET_TFA_DATA_SUCCESS,
		payload: { data },
	};
}

export function getTFADataError() {
	return {
		type: sharedTypes.GET_TFA_DATA_ERROR,
	};
}

export function setTFACode(data) {
	return {
		type: sharedTypes.SET_TFA_CODE,
		payload: data,
	};
}

export function setTFACodeSuccess() {
	return {
		type: sharedTypes.SET_TFA_CODE_SUCCESS,
	};
}

export function setTFACodeError() {
	return {
		type: sharedTypes.SET_TFA_CODE_ERROR,
	};
}

export function clearTFAState() {
	return {
		type: sharedTypes.CLEAR_TFA_STATE,
	};
}
